/* AEVUM — interactions du thème (sans dépendance) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header : état "scrollé" + menu mobile ---------- */
  function initHeader(root) {
    var header = root.querySelector('.ae-header');
    if (header && header.classList.contains('ae-header--sticky')) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var drawer = root.querySelector('.ae-drawer');
    if (!drawer) return;
    var openers = root.querySelectorAll('[data-ae-open]');
    var closers = drawer.querySelectorAll('[data-ae-close]');
    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var first = drawer.querySelector('a'); if (first) first.focus(); }
    }
    openers.forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    closers.forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- HUD : compteur + fluctuation "temps réel" ---------- */
  function fmt(v, decimals, sep) {
    var s = v.toFixed(decimals);
    if (sep) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return s;
  }

  function initHud(section) {
    var values = section.querySelectorAll('[data-ae-value]');
    var live = section.getAttribute('data-ae-live') === 'true';
    var started = false;

    function countUp() {
      if (started) return;
      started = true;
      values.forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-ae-value'));
        var dec = parseInt(el.getAttribute('data-ae-decimals') || '0', 10);
        var sep = target >= 1000;
        if (reduce) { el.textContent = fmt(target, dec, sep); return; }
        var t0 = null, dur = 1400;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 4);
          el.textContent = fmt(target * e, dec, sep);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
      if (live && !reduce) setTimeout(jitter, 1800);
    }

    function jitter() {
      values.forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-ae-value'));
        var dec = parseInt(el.getAttribute('data-ae-decimals') || '0', 10);
        var amp = Math.max(Math.abs(target) * 0.012, dec ? Math.pow(10, -dec) : 1);
        var v = target + (Math.random() * 2 - 1) * amp;
        el.textContent = fmt(v, dec, target >= 1000);
      });
      setTimeout(jitter, 1100 + Math.random() * 600);
    }

    /* Radar : les points dérivent doucement autour de leur position */
    var dots = section.querySelectorAll('[data-ae-dot]');
    if (dots.length && !reduce) {
      var base = [];
      dots.forEach(function (d) { base.push({ x: +d.getAttribute('cx'), y: +d.getAttribute('cy') }); });
      var t = 0;
      (function loop() {
        t += 0.012;
        dots.forEach(function (d, i) {
          var k = i + 1;
          d.setAttribute('cx', (base[i].x + Math.sin(t * k * 0.9 + k) * 2.2).toFixed(2));
          d.setAttribute('cy', (base[i].y + Math.cos(t * k * 0.7 + k) * 1.8).toFixed(2));
        });
        requestAnimationFrame(loop);
      })();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { countUp(); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(section);
    } else {
      countUp();
    }
  }

  /* ---------- Apparition des sections au scroll ---------- */
  function initInview(root) {
    var els = root.querySelectorAll('.ae-inview');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.18 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Vidéo transparente : choix de la source ----------
     HEVC alpha (.mov) : uniquement Safari macOS et tous les navigateurs iOS/iPadOS (WebKit).
     Chrome Mac sait lire le HEVC mais ignore son alpha (fond noir) : il reçoit le WebM. */
  function appleWebKit() {
    var ua = navigator.userAgent || '';
    if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return true;
    return /Safari\//.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/.test(ua);
  }
  function pickSource(v) {
    var webm = v.getAttribute('data-src-webm'), hevc = v.getAttribute('data-src-hevc');
    if (hevc && appleWebKit() && (v.canPlayType('video/mp4; codecs="hvc1"') || v.canPlayType('video/quicktime'))) return hevc;
    if (webm && v.canPlayType('video/webm; codecs="vp9"')) return webm;
    return hevc || webm || '';
  }

  /* ---------- Lecteur vidéo au clic (section Statera) ----------
     Modes : fade (fondu sur place) | section (agrandi dans la section) | fullscreen
     Mobile (< 990px) ou réduction des animations : toujours "fade". */
  function initPlayers(root) {
    root.querySelectorAll('[data-ae-player]').forEach(function (sec) {
      if (sec.dataset.aePlayerReady) return;
      sec.dataset.aePlayerReady = '1';
      var btn = sec.querySelector('[data-ae-play]');
      var vid = sec.querySelector('.ae-statera__video') || sec.querySelector('video');
      var media = sec.querySelector('.ae-statera__media');
      if (!btn || !vid || !media) return;
      var label = btn.querySelector('.ae-play__label');
      var stopLabel = sec.getAttribute('data-ae-stop') || 'Arrêter';
      vid.muted = true; vid.playsInline = true; vid.loop = sec.hasAttribute('data-ae-loop');
      var stage = null, inner = null, closeBtn = null, mode = 'fade', busy = false;
      var DUR = parseInt(sec.getAttribute('data-ae-dur') || '1600', 10) || 1600;

      function wanted() {
        var m = sec.getAttribute('data-ae-mode') || 'fullscreen';
        if (window.innerWidth < 990 || reduce) return 'fade';
        return m;
      }
      function setLabel(on) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (label) label.textContent = on ? label.dataset.labelStop : label.dataset.labelPlay;
      }
      var alpha = vid.hasAttribute('data-src-webm') || vid.hasAttribute('data-src-hevc');
      function prime() {
        if (vid.preload !== 'none') return;
        vid.preload = 'auto';
        if (alpha && !vid.getAttribute('src')) { var src = pickSource(vid); if (src) vid.src = src; }
        try { vid.load(); } catch (e) {}
      }
      if ('IntersectionObserver' in window) {
        var pio = new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { prime(); pio.disconnect(); } });
        }, { rootMargin: '300px' });
        pio.observe(sec);
      }
      btn.addEventListener('pointerenter', prime);

      /* ----- Chapitres de la vue éclatée : arrêts + repères -----
         Moments et positions : JSON exporté par Blender (script [data-ae-reperes]).
         Réglages par chapitre (arrêt, durée, titre) : data-ae-chapters="1~4~Ensemble|…" */
      var callouts = sec.querySelector('[data-ae-callouts]');
      var items = callouts ? [].slice.call(callouts.querySelectorAll('.ae-callout')) : [];
      var allStops = [], stops = [], next = 0, watchId = 0, holdT = 0, held = false;
      /* repères de temps pour le repli : ouverture / fermeture (JSON Blender, sinon estimés) */
      var tl = { opD: null, opF: null, ferD: null, ferF: null, firstCh: null, lastFin: null };

      (function setupChapters() {
        var el = sec.querySelector('[data-ae-reperes]'), data = null;
        try { data = el ? JSON.parse(el.textContent) : null; } catch (e) { data = null; }
        if (!data || !data.chapitres || !data.chapitres.length) return;
        var cfg = (sec.getAttribute('data-ae-chapters') || '').split('|').map(function (s) {
          var a = s.split('~');
          return { pause: a[0] !== '0', hold: parseFloat(a[1]) || 4, title: a.slice(2).join('~') };
        });
        var chs = data.chapitres.slice().sort(function (x, y) { return x.debut_s - y.debut_s; });
        var byId = {};
        chs.forEach(function (c) { byId[c.id] = c; });
        if (callouts) callouts.setAttribute('data-chapters', chs.length);
        /* place chaque repère sur la position Blender de sa clé "chapitre.élément" */
        items.forEach(function (it) {
          var k = (it.getAttribute('data-key') || '').split('.');
          var c = byId[k[0]] || chs[0];
          var r = c.reperes && k[1] && c.reperes[k[1]];
          if (r) { it.style.setProperty('--x', r.x + '%'); it.style.setProperty('--y', r.y + '%'); }
          it.setAttribute('data-ch', c.id);
        });
        chs.forEach(function (c, i) {
          var cf = cfg[i] || { pause: true, hold: 4, title: '' };
          var span = Math.max(0, (c.fin_s || c.debut_s) - c.debut_s);
          allStops.push({
            t: c.debut_s + Math.min(0.2, span / 4), hold: cf.hold * 1000, pause: cf.pause,
            n: i + 1, total: chs.length, title: cf.title || c.id, id: c.id
          });
        });
        stops = allStops.filter(function (s) { return s.pause; });
        tl.firstCh = chs[0].debut_s;
        tl.lastFin = chs[chs.length - 1].fin_s || chs[chs.length - 1].debut_s;
        if (data.ouverture) { tl.opD = +data.ouverture.debut_s; tl.opF = +data.ouverture.fin_s; }
        if (data.fermeture) { tl.ferD = +data.fermeture.debut_s; tl.ferF = +data.fermeture.fin_s; }
      })();
      function timeline() {
        var d = vid.duration || 0;
        var opF = tl.opF != null ? tl.opF : (tl.firstCh != null ? tl.firstCh : Math.min(4, d / 4));
        var opD = tl.opD != null ? tl.opD : Math.max(0, opF - 2.8);
        var ferF = tl.ferF != null ? tl.ferF : Math.max(0, d - 0.2);
        var ferD = tl.ferD != null ? tl.ferD : Math.max(tl.lastFin != null ? tl.lastFin + 1 : 0, ferF - (opF - opD));
        return { opD: opD, opF: opF, ferD: ferD, ferF: ferF, d: d };
      }

      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function setTxt(sel, v) { var e = callouts && callouts.querySelector(sel); if (e) e.textContent = v; }
      function posFactor(v) {
        if (v === 'left' || v === 'top') return 0;
        if (v === 'right' || v === 'bottom') return 1;
        if (v === 'center') return 0.5;
        var n = parseFloat(v); return isNaN(n) ? 0.5 : n / 100;
      }
      /* cale le calque des repères sur l'image réellement affichée (object-fit: contain) */
      function fitCallouts() {
        if (!callouts || !vid.videoWidth) return;
        var bw = vid.clientWidth, bh = vid.clientHeight, r = vid.videoWidth / vid.videoHeight, cw, ch;
        if (!bw || !bh) return;
        if (bw / bh > r) { ch = bh; cw = bh * r; } else { cw = bw; ch = bw / r; }
        var op = (getComputedStyle(vid).objectPosition || '50% 50%').split(/\s+/);
        var fx = posFactor(op[0]), fy = posFactor(op[1] || op[0]);
        callouts.style.left = (vid.offsetLeft + (bw - cw) * fx) + 'px';
        callouts.style.top = (vid.offsetTop + (bh - ch) * fy) + 'px';
        callouts.style.width = cw + 'px';
        callouts.style.height = ch + 'px';
      }
      function showStop(st) {
        if (!callouts) return;
        var i = 0;
        items.forEach(function (it) {
          var on = it.getAttribute('data-ch') === st.id;
          it.classList.toggle('is-cur', on);
          if (on) it.style.setProperty('--i', i++);
        });
        setTxt('[data-ae-chap-n]', pad(st.n));
        setTxt('[data-ae-chap-total]', '/' + pad(st.total));
        setTxt('[data-ae-chap-t]', st.title);
        fitCallouts();
        callouts.classList.add('is-on');
        fillLegend(st);
      }
      function hideCallouts() { if (callouts) callouts.classList.remove('is-on'); if (legend) legend.classList.remove('is-on'); }
      var forced = null, cur = null, nav = null;
      function target() { return forced || stops[next] || null; }
      function watch() {
        var st = target();
        if (!st || vid.paused) return;
        if (vid.currentTime >= st.t) { startHold(st); return; }
        watchId = requestAnimationFrame(watch);
      }
      function arm() { cancelAnimationFrame(watchId); if (target()) watchId = requestAnimationFrame(watch); }
      function startHold(st) {
        cancelAnimationFrame(watchId);
        held = true; cur = st; forced = null;
        next = 0;
        while (next < stops.length && stops[next].t <= st.t + 0.01) next++;
        vid.pause();
        if (stage) stage.classList.add('is-held');
        showStop(st);
        navUpdate(true);
        holdT = setTimeout(resume, st.hold);
      }
      function resume() {
        if (!held) return;
        held = false;
        clearTimeout(holdT);
        hideCallouts();
        navUpdate(false);
        if (stage) stage.classList.remove('is-held');
        setTimeout(function () {
          if (sec.classList.contains('is-playing') && !held) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
        }, 380);
      }
      function resetHold() {
        cancelAnimationFrame(watchId); clearTimeout(holdT);
        held = false; next = 0; forced = null; cur = null;
        hideCallouts();
        navUpdate(false);
        if (stage) stage.classList.remove('is-held');
      }

      /* ----- Navigation entre chapitres : 01 · 02 · 03 · Quitter ----- */
      function buildNav(host) {
        if (!allStops.length) return;
        nav = document.createElement('nav');
        nav.className = 'ae-chapnav ae-mono';
        nav.setAttribute('aria-label', 'Chapitres');
        allStops.forEach(function (st, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ae-chapnav__item';
          b.innerHTML = '<b>' + pad(st.n) + '</b><span>' + st.title + '</span><i class="ae-chapnav__bar" aria-hidden="true"></i>';
          b.addEventListener('click', function (e) { e.stopPropagation(); goTo(i); });
          nav.appendChild(b);
        });
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'ae-chapnav__item ae-chapnav__exit';
        x.innerHTML = '<span>' + stopLabel + '</span><b aria-hidden="true">×</b>';
        x.addEventListener('click', function (e) { e.stopPropagation(); exit(); });
        nav.appendChild(x);
        /* fondu sur place : la barre prend la place du bouton, juste sous la vidéo */
        if (host === sec && btn.parentNode === sec) sec.insertBefore(nav, btn.nextSibling); else host.appendChild(nav);
        requestAnimationFrame(function () { if (nav) nav.classList.add('is-on'); });
      }
      function removeNav() { if (nav && nav.parentNode) nav.parentNode.removeChild(nav); nav = null; removeLegend(); }

      /* ----- Mobile : repères numérotés sur la vidéo + légende lisible en dessous ----- */
      var legend = null;
      function buildLegend() {
        if (legend || !callouts || !allStops.length || window.innerWidth >= 990) return;
        var max = 0;
        allStops.forEach(function (st) {
          var n = items.filter(function (it) { return it.getAttribute('data-ch') === st.id; }).length;
          if (n > max) max = n;
        });
        legend = document.createElement('div');
        legend.className = 'ae-clegend ae-mono';
        legend.setAttribute('aria-live', 'polite');
        legend.style.setProperty('--rows', max || 4);
        legend.innerHTML = '<p class="ae-clegend__head"><b></b><span></span><i></i></p><ol class="ae-clegend__list"></ol>';
        var after = (nav && nav.parentNode === sec) ? nav : btn;
        sec.insertBefore(legend, after.nextSibling);
      }
      function fillLegend(st) {
        if (!legend) return;
        legend.querySelector('.ae-clegend__head b').textContent = pad(st.n);
        legend.querySelector('.ae-clegend__head span').textContent = '/' + pad(st.total);
        legend.querySelector('.ae-clegend__head i').textContent = st.title;
        var ol = legend.querySelector('ol');
        ol.innerHTML = '';
        items.forEach(function (it) {
          if (it.getAttribute('data-ch') !== st.id) return;
          var lab = it.querySelector('.ae-callout__label'), val = it.querySelector('.ae-callout__value');
          var li = document.createElement('li');
          var a = document.createElement('span'); a.className = 'ae-clegend__lab'; a.textContent = lab ? lab.textContent.trim() : '';
          var b = document.createElement('b'); b.className = 'ae-clegend__val'; b.textContent = val ? val.textContent.trim() : '';
          li.appendChild(a); li.appendChild(b); ol.appendChild(li);
        });
        legend.classList.add('is-on');
      }
      function removeLegend() { if (legend && legend.parentNode) legend.parentNode.removeChild(legend); legend = null; }
      function navUpdate(running) {
        if (!nav) return;
        var btns = nav.querySelectorAll('.ae-chapnav__item:not(.ae-chapnav__exit)');
        for (var i = 0; i < btns.length; i++) {
          var on = cur === allStops[i];
          btns[i].classList.toggle('is-active', on);
          btns[i].classList.toggle('is-running', on && running);
          btns[i].setAttribute('aria-current', on ? 'step' : 'false');
          if (on) btns[i].style.setProperty('--hold', allStops[i].hold + 'ms');
        }
      }
      /* Aller à un chapitre : vers le suivant immédiat = la vidéo joue la transition ;
         sinon (retour arrière, saut) = fondu très court et recalage direct */
      function goTo(i) {
        var st = allStops[i];
        if (!st || busy || !sec.classList.contains('is-playing')) return;
        if (held && cur === st) return;
        clearTimeout(holdT); cancelAnimationFrame(watchId);
        held = false; hideCallouts();
        if (stage) stage.classList.remove('is-held');
        var t = vid.currentTime;
        var between = allStops.some(function (s) { return s !== st && s.t > t + 0.05 && s.t < st.t; });
        cur = st; navUpdate(false);
        if (st.t > t + 0.05 && !between) {
          forced = st;
          var p = vid.play(); if (p && p.catch) p.catch(function () {});
          arm();
          return;
        }
        vid.pause();
        vid.classList.add('is-dip');
        setTimeout(function () {
          seekThen(st.t, function () { vid.classList.remove('is-dip'); startHold(st); });
        }, 240);
      }
      window.addEventListener('resize', function () { if (held || sec.hasAttribute('data-ae-preview')) fitCallouts(); });
      vid.addEventListener('play', function () { if (!held) arm(); });
      /* boucle ou retour en arrière : on recale le prochain arrêt */
      vid.addEventListener('seeked', function () {
        if (held || forced) return;
        next = 0;
        while (next < stops.length && stops[next].t <= vid.currentTime) next++;
        if (!vid.paused) arm();
      });

      function play() {
        resetHold();
        try { vid.currentTime = 0; } catch (e) {}
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
      }
      function openFade() {
        setLabel(true);
        if (!nav) buildNav(sec);
        buildLegend();
        if (!alpha) { sec.classList.add('is-playing'); play(); return; }
        /* transparent : on attend la 1re image décodée pour ne jamais laisser un trou */
        var shown = false;
        function show() { if (shown) return; shown = true; vid.removeEventListener('playing', show); sec.classList.add('is-playing'); }
        vid.addEventListener('playing', show);
        setTimeout(show, 1500);
        play();
      }
      function closeFade() { resetHold(); vid.pause(); sec.classList.remove('is-playing'); setLabel(false); }
      /* clic sur la vidéo pendant l'arrêt = reprise */
      media.addEventListener('click', function () { if (held) resume(); });

      function fromTransform(target) {
        var r = media.getBoundingClientRect();
        var s = Math.min(r.width / target.width, r.height / target.height);
        var dx = (r.left + r.width / 2) - (target.left + target.width / 2);
        var dy = (r.top + r.height / 2) - (target.top + target.height / 2);
        return 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')';
      }
      function targetRect() {
        if (mode === 'fullscreen') return { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
        return sec.getBoundingClientRect();
      }
      function openExpand() {
        busy = true;
        stage = document.createElement('div');
        stage.className = 'ae-scope ae-stage ae-stage--' + mode + (alpha ? ' ae-stage--alpha' : '');
        stage.style.setProperty('--ae-xdur', DUR + 'ms');
        var veil = sec.getAttribute('data-ae-veil'), blur = sec.getAttribute('data-ae-blur');
        if (veil !== null) stage.style.setProperty('--ae-veil', (parseInt(veil, 10) || 0) / 100);
        if (blur !== null) stage.style.setProperty('--ae-blur', (parseInt(blur, 10) || 0) + 'px');
        var vh = sec.getAttribute('data-ae-veil-hold');
        if (vh !== null) stage.style.setProperty('--ae-veil-hold', (parseInt(vh, 10) || 0) / 100);
        inner = document.createElement('div');
        inner.className = 'ae-stage__inner';
        stage.appendChild(inner);
        closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'ae-tool ae-stage__close';
        closeBtn.innerHTML = stopLabel + ' <span class="ae-tool__count">×</span>';
        closeBtn.addEventListener('click', exit);
        stage.appendChild(closeBtn);
        buildNav(stage);
        /* état de départ posé SANS transition, à la place exacte du visuel */
        inner.style.transition = 'none';
        inner.style.opacity = '0';
        inner.style.transform = fromTransform(targetRect());
        (mode === 'fullscreen' ? document.body : sec).appendChild(stage);
        inner.appendChild(vid);
        if (callouts) inner.appendChild(callouts);
        stage.addEventListener('click', function (e) { if (held && !e.target.closest('.ae-stage__close')) resume(); });
        inner.style.transform = fromTransform(targetRect());
        if (mode === 'fullscreen') document.documentElement.style.overflow = 'hidden';
        sec.classList.add('is-expanded', 'is-playing');
        setLabel(true);
        void inner.offsetWidth; /* le navigateur enregistre le point de départ */
        /* deux images plus tard : on lance l'agrandissement (fiable sur Safari) */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            inner.style.transition = '';
            stage.classList.add('is-open');
            inner.style.opacity = '1';
            inner.style.transform = 'none';
          });
        });
        setTimeout(play, DUR * 0.7); /* la vidéo démarre quand la raquette est presque arrivée */
        setTimeout(function () { busy = false; try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }, DUR + 60);
      }
      function closeExpand() {
        busy = true;
        resetHold();
        vid.pause();
        stage.classList.remove('is-open');
        inner.style.transform = fromTransform(targetRect());
        sec.classList.remove('is-expanded');
        setLabel(false);
        setTimeout(function () {
          sec.classList.remove('is-playing');
          media.appendChild(vid);
          if (callouts) media.appendChild(callouts);
          try { vid.currentTime = 0; } catch (e) {}
          if (stage && stage.parentNode) stage.parentNode.removeChild(stage);
          stage = inner = closeBtn = null;
          document.documentElement.style.overflow = '';
          busy = false;
          try { btn.focus({ preventScroll: true }); } catch (e) {}
        }, DUR);
      }
      function open() {
        if (busy) return;
        prime();
        mode = wanted();
        if (mode === 'fade') openFade(); else openExpand();
      }
      /* fermeture immédiate (sortie de l'écran, fin de vidéo, 2e Échap) */
      function close() {
        removeNav();
        vid.playbackRate = 1;
        vid.loop = sec.hasAttribute('data-ae-loop');
        vid.classList.remove('is-dip');
        if (busy || !sec.classList.contains('is-playing')) return;
        if (stage) closeExpand(); else closeFade();
      }

      /* ----- Sortie propre (Échap, ×, Quitter) : tout s'efface en fondu, la photo revient ----- */
      function seekThen(time, cb) {
        var done = false;
        var f = function () { if (done) return; done = true; vid.removeEventListener('seeked', f); cb(); };
        vid.addEventListener('seeked', f);
        setTimeout(f, 900);
        try { vid.currentTime = time; } catch (e) { f(); }
      }
      function exit() {
        if (loading) { stopLoading(); return; }
        if (busy || !sec.classList.contains('is-playing')) return;
        resetHold();
        vid.pause();
        vid.classList.remove('is-dip');
        setLabel(false);
        if (!stage) { removeNav(); closeFade(); return; }
        busy = true;
        stage.classList.add('is-leaving');
        sec.classList.remove('is-expanded', 'is-playing');   /* la photo et les textes reviennent sous le fondu */
        setTimeout(function () {
          media.appendChild(vid);
          if (callouts) media.appendChild(callouts);
          try { vid.currentTime = 0; } catch (e) {}
          removeNav();
          if (stage && stage.parentNode) stage.parentNode.removeChild(stage);
          stage = inner = closeBtn = null;
          document.documentElement.style.overflow = '';
          busy = false;
          try { btn.focus({ preventScroll: true }); } catch (e) {}
        }, 560);
      }

      /* ----- Chargement : anneau stylisé tant que le 1er chapitre n'est pas en mémoire ----- */
      var loading = false, loadT = 0;
      function needT() { return stops.length ? stops[0].t + 0.6 : 3; }
      function bufferedEnd() {
        var b = vid.buffered, ct = vid.currentTime;
        for (var i = 0; i < b.length; i++) { if (b.start(i) <= ct + 0.2 && b.end(i) >= ct) return b.end(i); }
        return 0;
      }
      function ready() {
        if (vid.readyState >= 4) return true;
        if (!(vid.duration > 0)) return false;
        return bufferedEnd() >= Math.min(needT(), vid.duration - 0.1);
      }
      function stopLoading() {
        loading = false; clearTimeout(loadT);
        sec.classList.remove('is-loading');
        btn.style.removeProperty('--p');
        vid.pause();
        try { vid.currentTime = 0; } catch (e) {}
        if (label) label.textContent = label.dataset.labelPlay;
      }
      function load(then) {
        prime();
        if (ready()) { then(); return; }
        loading = true;
        sec.classList.add('is-loading');
        var t0 = Date.now();
        /* iOS ignore le préchargement : un play() muet (déclenché par le clic) lance le téléchargement */
        var p = vid.play();
        if (p && p.then) p.then(function () { if (loading) vid.pause(); }).catch(function () {});
        (function tick() {
          if (!loading) return;
          var goal = Math.min(needT(), vid.duration || needT());
          var pct = vid.duration > 0 ? Math.max(0, Math.min(100, Math.round(bufferedEnd() / goal * 100))) : 0;
          btn.style.setProperty('--p', pct);
          if (label) label.textContent = (label.dataset.labelLoad || 'Chargement') + ' ' + pct + '%';
          if (ready() || Date.now() - t0 > 15000) { btn.style.setProperty('--p', 100); stopLoading(); then(); return; }
          loadT = setTimeout(tick, 120);
        })();
      }

      btn.addEventListener('click', function () {
        if (loading) { stopLoading(); return; }
        if (sec.classList.contains('is-playing')) exit(); else load(open);
      });
      vid.addEventListener('ended', function () { if (!vid.loop) close(); });
      document.addEventListener('keydown', function (e) {
        if (!sec.classList.contains('is-playing') && !loading) return;
        if (e.key === 'Escape') exit();
        else if (e.key === 'ArrowRight' && allStops.length) { var i = cur ? allStops.indexOf(cur) + 1 : 0; if (i < allStops.length) goTo(i); }
        else if (e.key === 'ArrowLeft' && cur) { var j = allStops.indexOf(cur) - 1; if (j >= 0) goTo(j); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (!e.isIntersecting && mode !== 'fullscreen') close(); });
        }, { threshold: 0 }).observe(sec);
      }

      /* Éditeur Shopify : aperçu figé sur un chapitre pour régler ses repères */
      var pv = parseInt(sec.getAttribute('data-ae-preview') || '0', 10);
      if (pv && callouts && allStops[pv - 1]) {
        var st = allStops[pv - 1];
        prime();
        var showPreview = function () {
          try { vid.currentTime = st.t; } catch (e) {}
          vid.addEventListener('seeked', function once() {
            vid.removeEventListener('seeked', once);
            sec.classList.add('is-playing');
            showStop(st);
          });
        };
        if (vid.readyState >= 1) showPreview(); else vid.addEventListener('loadedmetadata', showPreview, { once: true });
      }
    });
  }

  function init(root) {
    root = root || document;
    document.documentElement.classList.add('ae-io');
    initHeader(root);
    initInview(root);
    initPlayers(root);
    root.querySelectorAll('[data-ae-hud]').forEach(initHud);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Éditeur de thème Shopify : ré-initialiser une section rechargée */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
